import { httpClient } from "src/shared/services/httpClient";

export const ggpsLogin = ({ mode }: { mode: string }) =>
  httpClient.get(`welcome/ggpsLogin?mode=${mode}`);
